// extracted by css-extract-rspack-plugin
export default {"portfolio":"portfolio--JxjGz1dapnMO3T4G","artifact":"artifact--jmMKLS3e_6UL6UO6"};